import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import StatusIndicator from '@/src/components/project/Common/StatusIndicator/StatusIndicator';

const TaskItem = ({ task, onOpenTask }) => {
  const handleOpenTask = () => {
    onOpenTask(task.id);
  };

  const hasLongName = task.name.length > 20;
  const taskName = hasLongName ? `${task.name.substring(0, 20)}...` : task.name;
  const tooltipId = `ti_${task.id}_tooltip`;

  return (
    <div className="actionItem">
      <Button
        className={clsx(
          'tw-w-full',
          'tw-py-[6px]',
          'hover:tw-bg-cfo-blue-200 hover:tw-font-brandonTextMedium'
        )}
        buttonClassSettings={{ variant: 'style_unset', position: 'between', size: 'sm' }}
        onClick={handleOpenTask}
        data-tooltip-id={tooltipId}
      >
        <span className={clsx('tw-text-cfo-blue-600', 'group-hover:tw-underline')}>{taskName}</span>
        <StatusIndicator status={task.status} />

        {hasLongName && (
          <Tooltip className="subjectTooltip" id={tooltipId} place="left" effect="solid">
            {task.name}
          </Tooltip>
        )}
      </Button>
    </div>
  );
};

export default TaskItem;
